import "./styles/main.css";
import { aplicarTema, carregarWhitelabel, WhitelabelConfig } from "./config/whitelabel";
import { limparSessao, renovarSessao, sessaoAtual, SessaoUsuario } from "./api/auth";
import { alternarSidebarRecolhida, itensPermitidos, renderSidebar } from "./components/sidebar";
import { renderTopbar } from "./components/topbar";
import { montarLogin } from "./pages/login";
import { montarDashboard } from "./pages/dashboard";
import { montarTabela } from "./pages/tabela";
import { montarGrafico } from "./pages/grafico";
import { montarMapa } from "./pages/mapa";
import { montarAlertas } from "./pages/alertas";
import { montarConfiguracoes } from "./pages/configuracoes";
import { renderConstrucao } from "./pages/construcao";

const ROTA_PADRAO = "dashboard";

async function montarPagina(
  rota: string,
  config: WhitelabelConfig,
  sessao: SessaoUsuario,
  conteudoEl: HTMLElement
): Promise<void> {
  switch (rota) {
    case "dashboard":
      return montarDashboard(conteudoEl);
    case "tabela":
      return montarTabela(conteudoEl);
    case "grafico":
      return montarGrafico(conteudoEl);
    case "mapa":
      return montarMapa(conteudoEl, config, sessao.layerAccess);
    case "alertas":
      return montarAlertas(conteudoEl);
    case "configuracoes":
      return montarConfiguracoes(conteudoEl, sessao);
    default:
      conteudoEl.innerHTML = renderConstrucao(rota);
  }
}

function rotaAtual(): string {
  return location.hash.replace(/^#\/?/, "") || ROTA_PADRAO;
}

let intervaloRenovacaoSessao: ReturnType<typeof setInterval> | undefined;

async function montarShell(config: WhitelabelConfig, app: HTMLElement): Promise<void> {
  const sessao = sessaoAtual();
  if (intervaloRenovacaoSessao) clearInterval(intervaloRenovacaoSessao);
  if (!sessao) {
    montarLogin(app, config, () => montarShell(config, app));
    return;
  }

  // Renova o token periodicamente (bem dentro da validade de 8h) enquanto o
  // app fica aberto, pra nao deslogar o usuario no meio do uso so' por prazo.
  intervaloRenovacaoSessao = setInterval(renovarSessao, 60 * 60 * 1000);

  async function render() {
    let rota = rotaAtual();
    // pageAccess vazio = irrestrito; lista nao vazia restringe rotas do menu
    // (configuracoes fica sempre liberada - ver itensPermitidos). Se a rota
    // atual nao esta liberada, cai no primeiro item permitido do usuario.
    const permitidos = itensPermitidos(sessao!.pageAccess);
    if (!permitidos.some((item) => item.rota === rota)) {
      rota = permitidos[0]?.rota || "configuracoes";
      location.hash = "#/" + rota;
    }

    app.innerHTML = `
      ${renderSidebar(config, rota, sessao!.pageAccess)}
      <div class="shell">
        ${renderTopbar(rota, sessao!)}
        <main class="conteudo" id="conteudo"></main>
      </div>
    `;

    app.querySelectorAll<HTMLButtonElement>(".sidebar__link").forEach((botao) => {
      botao.addEventListener("click", () => {
        // Itens com "href" (ex: GIS/M13, app separado) sao link de saida -
        // abrem em aba nova, nao mudam a rota interna do M7.
        if (botao.dataset.href) {
          window.open(botao.dataset.href, "_blank", "noopener");
          return;
        }
        location.hash = "#/" + botao.dataset.rota;
      });
    });

    app.querySelector("#sidebar-alternar")?.addEventListener("click", () => {
      alternarSidebarRecolhida();
      render();
    });

    app.querySelector("#botao-sair")?.addEventListener("click", (ev) => {
      ev.preventDefault();
      limparSessao();
      montarShell(config, app);
    });

    const conteudoEl = app.querySelector("#conteudo") as HTMLElement;
    try {
      await montarPagina(rota, config, sessao!, conteudoEl);
    } catch (e) {
      if (String(e).includes("SessaoExpirada") || String((e as Error)?.message).includes("sessao expirada")) {
        limparSessao();
        montarShell(config, app);
        return;
      }
      conteudoEl.innerHTML = `<div class="card">Erro ao carregar: ${e}</div>`;
    }
  }

  window.addEventListener("hashchange", render);
  await render();
}

async function main() {
  const config = await carregarWhitelabel();
  aplicarTema(config);

  const app = document.getElementById("app")!;
  await montarShell(config, app);
}

main();
